import { createRouter } from "@tanstack/react-router"
import { Route as RootRoute } from "./routes/__root"
import { Route as ActivityFeedRoute } from "./routes/activity/index"
import { Route as DocumentDetailRoute } from "./routes/documents/$documentId"
import { Route as HeistDetailRoute } from "./routes/heists/$heistId"
import { Route as HeistsIndexRoute } from "./routes/heists/index"
import { Route as IndexRoute } from "./routes/index"
import { Route as LotDetailRoute } from "./routes/lots/$lotId"
import { Route as LotsIndexRoute } from "./routes/lots/index"
import { Route as NotificationsInboxRoute } from "./routes/notifications/index"
import { Route as OnboardingIndexRoute } from "./routes/onboarding/index"
import { Route as OnboardingStep1Route } from "./routes/onboarding/step-1"
import { Route as OnboardingStep2Route } from "./routes/onboarding/step-2"
import { Route as OnboardingStep3Route } from "./routes/onboarding/step-3"
import { Route as OnboardingStep4Route } from "./routes/onboarding/step-4"
import { Route as OnboardingStep5Route } from "./routes/onboarding/step-5"
import { Route as OnboardingStep6Route } from "./routes/onboarding/step-6"
import { Route as PartyDetailRoute } from "./routes/parties/$partyId"
import { Route as PartiesIndexRoute } from "./routes/parties/index"
import { Route as SettingsRoute } from "./routes/settings/index"
import { Route as RoleDetailRoute } from "./routes/settings/roles/$roleId"
import { Route as RolesIndexRoute } from "./routes/settings/roles/index"
import { Route as ShipmentDetailRoute } from "./routes/shipments/$shipmentId"
import { Route as ShipmentsIndexRoute } from "./routes/shipments/index"
import { Route as NewShipmentRoute } from "./routes/shipments/new"
import { Route as SignInRoute } from "./routes/sign-in"

const routeTree = RootRoute.addChildren([
	IndexRoute,
	SignInRoute,
	ShipmentsIndexRoute,
	// Static before dynamic: `/shipments/new` must not resolve as a
	// detail lookup for a shipment whose id is "new".
	NewShipmentRoute,
	ShipmentDetailRoute,
	DocumentDetailRoute,
	LotsIndexRoute,
	LotDetailRoute,
	PartiesIndexRoute,
	PartyDetailRoute,
	NotificationsInboxRoute,
	SettingsRoute,
	RolesIndexRoute,
	RoleDetailRoute,
	HeistsIndexRoute,
	HeistDetailRoute,
	ActivityFeedRoute,
	OnboardingIndexRoute,
	OnboardingStep1Route,
	OnboardingStep2Route,
	OnboardingStep3Route,
	OnboardingStep4Route,
	OnboardingStep5Route,
	OnboardingStep6Route,
])

export const router = createRouter({ routeTree })

declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router
	}
}
